export const PrimaryMarket_IPO = "PrimaryMarket_IPO";
export const PrimaryMarket_IPO_ADD_MSG = "PrimaryMarket_IPO_ADD_MSG";
export const PrimaryMarket_IPO_CLEAR_MSG = "PrimaryMarket_IPO_CLEAR_MSG";
export const PrimaryMarket_IPO_ERROR = "PrimaryMarket_IPO_ERROR";
export const PrimaryMarket_IPO_HIDE_ERROR = "PrimaryMarket_IPO_HIDE_ERROR";
export const PrimaryMarket_IPO_START_LOADER = "PrimaryMarket_IPO_START_LOADER";
export const PrimaryMarket_IPO_STOP_LOADER = "PrimaryMarket_IPO_STOP_LOADER";
